<template>
  <el-container>
    <el-dialog title="选择角色" :visible.sync="showDialog" width="30%" center>
      <changeRole :visible.sync="showDialog"></changeRole>
    </el-dialog>
    <el-header>
      <myHeader></myHeader>
    </el-header>
    <el-main>
      <div class="table-global mar-bottom-10 pad-bottom-0">
        <el-form :inline="true" :model="form" @submit.native.prevent>
          <el-row>
            <el-col :span="18" style="text-align: left">
              <el-form-item label="考试状态">
                <el-select v-model="form.zt">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="未开始" value="0"></el-option>
                  <el-option label="考试中" value="1"></el-option>
                  <el-option label="考试完成" value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="">
                <el-input
                  v-model="form.ksmc"
                  style="width: 400px"
                  placeholder="请输入考试名称"
                  @keyup.enter.native="query()"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="query()" id="query"
                  >查询</el-button
                >
              </el-form-item>
            </el-col>
            <el-col
              :span="6"
              style="text-align: right"
              v-if="$store.state.roleType === 'admin'"
            >
              <el-form-item>
                <el-button
                  type="warning"
                  style="color: white"
                  @click="flglDialogVisible = true"
                >
                  考试分类管理
                </el-button>
                <el-dialog
                  title="编辑分类"
                  :visible.sync="flglDialogVisible"
                  width="40%"
                  center
                  :close-on-click-modal="false"
                >
                  <classifyTreeEdit
                    type="exam"
                    :visible.sync="flglDialogVisible"
                  ></classifyTreeEdit>
                </el-dialog>
              </el-form-item>
              <el-button
                type="primary"
                style="color: white"
                @click="goCreateSurvey"
              >
                <i class="el-icon-plus">&emsp;创建考试</i>
              </el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="table-global">
        <el-table :data="tableData" :border="true">
          <el-table-column label="考试名称" width="200" prop="ksmc">
            <template slot-scope="scope">
              <router-link
                :to="{
                  path: '/exam/link',
                  query: {
                    ksid: scope.row.ksid,
                    zt: scope.row.zt,
                    ksmc: scope.row.ksmc
                  }
                }"
                >{{ scope.row.ksmc }}</router-link
              >
            </template>
          </el-table-column>
          <el-table-column label="考试类型" width="130" prop="flmc" />
          <el-table-column label="总分" width="60" prop="sjzf" />
          <el-table-column label="开始时间" width="155" prop="kfqssj" />
          <el-table-column label="结束时间" width="155" prop="kfjssj" />
          <el-table-column label="创建人" width="80" prop="cjrmc" />
          <el-table-column label="创建时间" width="155" prop="cjsj" />
          <el-table-column label="状态" width="80" prop="ztms" />
          <el-table-column label="操作" width="400">
            <template slot-scope="scope">
              <template v-if="!scope.row.czqx">
                <el-button
                  size="mini"
                  @click="handleMarkingPaper(scope.$index, scope.row)"
                  :disabled="scope.row.zt === '0'"
                  style="width: 100px; border-color: blue"
                >
                  阅卷</el-button
                >
              </template>
              <template v-if="scope.row.czqx">
                <el-button
                  size="mini"
                  @click="handleExamSetting(scope.$index, scope.row)"
                  type="info"
                >
                  考试设置</el-button
                >
                <el-button
                  size="mini"
                  @click="handlePublish(scope.$index, scope.row)"
                  :disabled="scope.row.zt !== '0' || !scope.row.sjzf"
                  type="success"
                >
                  发布</el-button
                >
                <el-button
                  size="mini"
                  @click="handleReport(scope.$index, scope.row)"
                  :disabled="scope.row.zt === '0' || !scope.row.sjzf"
                  type="primary"
                >
                  分析考试</el-button
                >
                <el-dropdown style="margin-left: 15px">
                  <el-button style="width: 110px">
                    更多操作<i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item class="d-button">
                      <el-button
                        size="mini"
                        @click="handleFinish(scope.$index, scope.row)"
                        :disabled="scope.row.zt !== '1'"
                        type="warning"
                        style="width: 100px"
                      >
                        考试结束</el-button
                      >
                    </el-dropdown-item>
                    <el-dropdown-item v-if="scope.row.yjqx" class="d-button">
                      <el-button
                        size="mini"
                        @click="handleMarkingPaper(scope.$index, scope.row)"
                        :disabled="scope.row.zt === '0'"
                        style="width: 100px; border-color: #6394dd"
                      >
                        阅卷</el-button
                      >
                    </el-dropdown-item>
                    <el-dropdown-item class="d-button">
                      <el-button
                        size="mini"
                        @click="handleClear(scope.$index, scope.row)"
                        :disabled="scope.row.zt === '0'"
                        type="danger"
                        style="width: 100px"
                      >
                        清空</el-button
                      >
                    </el-dropdown-item>
                    <el-dropdown-item class="d-button">
                      <el-button
                        size="mini"
                        @click="handleRemove(scope.$index, scope.row)"
                        :disabled="scope.row.zt === '1'"
                        type="danger"
                        style="width: 100px"
                      >
                        删除</el-button
                      >
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50]"
          :page-size="pageSize"
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
        >
        </el-pagination>
      </div>
    </el-main>
  </el-container>
</template>
<script>
import myHeader from '@/components/myHeader'
import { toMyExam } from '@/api/examinee'
import changeRole from '@/components/changeRole'
import classifyTreeEdit from '@/components/tree/classifyTreeEdit'
import * as exam from '@/api/exam'
export default {
  data () {
    return {
      showDialog: false, // 显示角色切换窗
      flglDialogVisible: false,
      form: {
        zt: '',
        ksmc: ''
      },
      currentPage: 1,
      pageSize: 10,
      totalNum: 0,
      tableData: [],
      isLast: true
    }
  },
  components: {
    myHeader,
    changeRole,
    classifyTreeEdit
  },
  methods: {
    toExaminee () {
      toMyExam(null).then(res => {
        this.$http.callback(res, () => {
          this.$store.commit('mobile/setUser', res.data.user)
          this.$store.commit('mobile/setToken', res.data.token)
          this.$store.commit('mobile/setAuth', res.data.auth)
          this.$router.push({
            path: '/examinee/list'
          })
        })
      })
    },
    // 创建考试
    goCreateSurvey () {
      this.$router.push({
        path: '/exam/add'
      })
    },
    // 分页
    handleSizeChange (val) {
      this.pageSize = val
      this.query(this.currentPage)
    },
    handleCurrentChange (val) {
      this.query(val)
    },
    // 查询
    query (currentPage = 1) {
      this.currentPage = currentPage
      const params = Object.assign(
        { pageNo: this.currentPage, pageSize: this.pageSize },
        this.form
      )
      exam.getList(params).then(res => {
        this.$http.callback(res, () => {
          const data = res.data
          this.tableData = data.list
          this.totalNum = data.count
        })
      })
    },
    // 考试设置
    handleExamSetting ($index, row) {
      const query = {
        ksid: row.ksid
      }
      this.$router.push({
        path: '/exam/setting',
        query: query
      })
    },
    // 发布
    handlePublish ($index, row) {
      this.$confirm('发布后不能再修改试卷，确定要发布考试吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const params = {
            ksid: row.ksid
          }
          exam.publish(params).then(res => {
            this.$http.callback(res, () => {
              this.$message.success(res.msg)
              this.query(this.currentPage)
            })
          })
        })
        .catch(() => {})
    },
    // 阅卷
    handleMarkingPaper ($index, row) {
      const query = {
        ksid: row.ksid
      }
      this.$router.push({
        path: '/markingPaper/list',
        query: query
      })
    },
    // 分析考试
    handleReport ($index, row) {
      const params = {
        ksid: row.ksid
      }
      this.$router.push({
        path: '/report',
        query: params
      })
    },
    // 考试结束
    handleFinish ($index, row) {
      this.$confirm('确定要结束考试吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const params = {
            ksid: row.ksid
          }
          exam.finish(params).then(res => {
            this.$http.callback(res, () => {
              this.$message.success(res.msg)
              this.query(this.currentPage)
            })
          })
        })
        .catch(() => {})
    },
    // 清空
    handleClear ($index, row) {
      this.$confirm('确定清空考试记录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const params = {
            ksid: row.ksid
          }
          exam.clear(params).then(res => {
            this.$http.callback(res, () => {
              this.$message.success(res.msg)
              this.query(this.currentPage)
            })
          })
        })
        .catch(() => {})
    },
    // 删除
    handleRemove ($index, row) {
      this.$confirm('确定删除该场考试?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const params = {
            ksid: row.ksid
          }
          exam.remove(params).then(res => {
            this.$http.callback(res, () => {
              this.$message.success(res.msg)
              this.query(this.currentPage)
            })
          })
        })
        .catch(() => {})
    }
  },
  created () {
    const url = window.location.href
    // const url = 'http://exam.pasok.cn/?auth=eyJ1c2VyIjp7ImRsbWMiOiIxMDMyOSIsInloemgiOiIxMDMyOSIsInh0YkFxanNMaXN0IjpbeyJ6aGlkIjoxLCJjanNqIjoiMjAyMC0wNy0yMSAxMjowMDowMCIsImNqcmpzIjoxLCJqc3NtIjoi5aSp57u05ZGY5belIiwianNseCI6IjEiLCJjanIiOjEwNjA2LCJqc2RoIjoxLCJqc21jIjoi5aSp57u05ZGY5belIn1dLCJ0eGR6IjoiIiwianNkaCI6MSwieWhtYyI6Iuacsee-pOaYnyIsInpjZnMiOiJFTSJ9LCJ0b2tlbiI6ImV5SmhiR2NpT2lKSVV6VXhNaUo5LmV5SmtiRzFqSWpvaU1UQXpNamtpZlEubVlMMzh5U25nUVNKMnJaSGJGX3dXMmRYSmlkR1h4NXFjYUxmWlBqRTF6OUZYUFgtVTNoVjctOGp4UXlINEtQNzFLUFBQandQRUhXRGQ3MnVVcEZzS1EifQ'
    const authIdx = url.indexOf('?auth=')
    if (authIdx !== -1) {
      let auth = url.substring(authIdx + 6, url.length)
      const Base64 = require('js-base64').Base64
      auth = Base64.decode(auth, 'utf-8')
      const authJson = JSON.parse(auth)
      // console.log(authJson)
      // window.localStorage.setItem('user', JSON.stringify(authJson.user))
      // window.localStorage.setItem('token', JSON.stringify(authJson.token))
      this.$store.commit('setUser', authJson.user)
      this.$store.commit('setToken', authJson.token)
      const xtbAqjsList = authJson.user.xtbAqjsList
      if (Array.isArray(xtbAqjsList) && xtbAqjsList.length > 1) {
        // 选择角色
        this.showDialog = true
        // 刷新浏览器地址
        this.$router.push({
          path: '/'
        })
      } else {
        if ('0,1,2,3'.indexOf(this.$store.state.user.jslx) !== -1) {
          this.$router.push({
            path: '/'
          })
        } else {
          this.toExaminee() // 没有管理员角色，直接进入考生中心
        }
      }
    }
  },
  activated () {
    if (!this.isLast) {
      this.query(this.currentPage)
    }
  },
  mounted () {
    // 进入页面后进行查询
    if (this.isLast) {
      this.query()
      this.isLast = false
    }
  }
}
</script>

<style scoped>
.d-button {
  margin-bottom: 4px;
}
</style>
